@if (title) {
    <h1 mat-dialog-title class="red-color">{{ title }}</h1>
}
<div mat-dialog-content class="red-color max-height" [innerHTML]="body">
</div>
@if (checkboxLabel) {
    <mat-checkbox [(ngModel)]="checkboxChecked">{{ checkboxLabel }}</mat-checkbox>
}
<div mat-dialog-actions>
    @if (cancelButton) {
        <button mat-button (click)="onCancelClick()">{{ cancelButton }}</button>
    }
    @if (successButton) {
        <button mat-button (click)="onSuccessClick()">{{ successButton }}</button>
    }
</div>
